import 'css-chunksrc/client/scenes/editTaskStatus/form/styles.scss';export default {
  "form": "_form_77ko8_1",
  "section": "_section_77ko8_10",
  "freeDateCheckBox": "_freeDateCheckBox_77ko8_28",
  "label": "_label_77ko8_37"
};